<!-- Header -->
<div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0; display: flex; align-items: center; justify-content: space-between;">
  <div class="flex items-center gap-3">
    <mat-icon style="color: #1C593D; font-size: 24px; width: 24px; height: 24px; flex-shrink: 0;">receipt_long</mat-icon>
    <h2 style="font-weight: 700; font-size: 1.05rem; color: #1e5a3f; margin: 0;">Detalle de Transacción</h2>
  </div>
  <button type="button" (click)="onNoClick()"
    style="width: 32px; height: 32px; border-radius: 50%; border: 1px solid #d1d5db; background: white; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: background 0.2s ease;"
    onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280; flex-shrink: 0;">close</mat-icon>
  </button>
</div>

<!-- Contenido -->
<div style="padding: 20px 24px; display: flex; flex-direction: column; gap: 10px;">

  <!-- Fecha -->
  <div style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
    <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Fecha</span>
    <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">{{ data.fechaCreacion | date:'medium' }}</p>
  </div>

  <!-- Beneficiario / Pagador -->
  <div *ngIf="data.motivo !== 'FONDEO WALLET'; else pagador">
    <div *ngIf="data.beneficiario" style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
      <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Beneficiario</span>
      <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">{{ data.beneficiario }}</p>
    </div>
  </div>
  <ng-template #pagador>
    <div *ngIf="data.pagador != 'Aguacate Investment'" style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
      <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Pagador</span>
      <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">{{ data.beneficiario }}</p>
    </div>
  </ng-template>

  <!-- Banco del beneficiario -->
  <div *ngIf="data.motivo !== 'FONDEO WALLET' && data.motivo !== 'AJUSTE DE BALANCE' && data.tipoTransaccion !== 'RETIRO' && data.motivo !== 'AC'"
    style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
    <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Banco del Beneficiario</span>
    <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">{{ motivoDisplay }}</p>
  </div>

  <!-- Cuenta de retiro -->
  <div *ngIf="data.tipoTransaccion === 'RETIRO'" style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
    <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Cuenta de Retiro</span>
    <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">{{ data.aliasRetiro }}</p>
  </div>

  <!-- Cuenta del beneficiario -->
  <div *ngIf="data.numeroCuenta != 'Abono Manual' && data.numeroCuenta"
    style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
    <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Cuenta del Beneficiario</span>
    <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 700; color: #2563eb; font-family: monospace;">{{ data.numeroCuenta }}</p>
  </div>

  <!-- Código transferencia -->
  <div *ngIf="data.codigo_transferencia != null"
    style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
    <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Código Transferencia</span>
    <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">{{ data.codigo_transferencia }}</p>
  </div>

  <!-- País origen / destino -->
  <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;"
    *ngIf="data.motivo != 'CRIPTOMONEDA' && data.tipoTransaccion !== 'RETIRO' && (data.pais_origen !== null || data.pais_destino !== null)">
    <div *ngIf="data.pais_origen !== null" style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
      <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">País Origen</span>
      <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">{{ data.paisOrigen ? data.paisOrigen : data.pais_origen }}</p>
    </div>
    <div *ngIf="data.pais_destino !== null && data.pais_destino != 'ZELLE'" style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
      <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">País Destino</span>
      <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">{{ data.paisDestino ? data.paisDestino : data.pais_destino }}</p>
    </div>
  </div>

  <!-- Tasa de conversión -->
  <div *ngIf="data.tipoTransaccion !== 'RETIRO' && data.motivo !== 'AC' && data.motivo !== 'FONDEO WALLET'"
    style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
    <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Tasa de Conversión</span>
    <p style="margin: 2px 0 0; font-size: 0.95rem; font-weight: 700; color: #7c3aed;">
      {{ tasaConversion ? (tasaConversion | number:'1.2-4') : '—' }}
    </p>
  </div>

  <!-- Montos -->
  <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
    <div *ngIf="data.tipoTransaccion !== 'RETIRO'" style="background: #f0fdf4; border-radius: 10px; padding: 12px 16px; border: 1px solid #bbf7d0;">
      <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Monto del Envío</span>
      <p style="margin: 2px 0 0; font-size: 0.95rem; font-weight: 700; color: #1e5a3f;">${{ data.monedaOrigen | currency:'':'':'1.2-2' }}</p>
    </div>
    <div *ngIf="data.monedaDestino != null && data.tipoTransaccion !== 'RETIRO'" style="background: #eff6ff; border-radius: 10px; padding: 12px 16px; border: 1px solid #bfdbfe;">
      <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Monto Destino</span>
      <p style="margin: 2px 0 0; font-size: 0.95rem; font-weight: 700; color: #2563eb;">${{ data.monedaDestino | currency:'':'':'1.2-2' }}</p>
    </div>
  </div>

  <!-- Retiro detalles -->
  <ng-container *ngIf="data.tipoTransaccion === 'RETIRO'">
    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
      <div style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
        <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Banco</span>
        <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">{{ data.banco }}</p>
      </div>
      <div style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
        <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Nº Cuenta</span>
        <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 700; color: #2563eb; font-family: monospace;">{{ data.numeroCuentaRetiro }}</p>
      </div>
    </div>
    <div *ngIf="data.monedaDestino != null" style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
      <div style="background: #f0fdf4; border-radius: 10px; padding: 12px 16px; border: 1px solid #bbf7d0;">
        <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Monto de Retiro</span>
        <p style="margin: 2px 0 0; font-size: 0.95rem; font-weight: 700; color: #1e5a3f;">{{ data.monedaDestino | currency:'$':'symbol':'4.2-2' }}</p>
      </div>
      <div style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
        <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Moneda Destino</span>
        <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">${{ data.tipoMonedaDestino }}</p>
      </div>
    </div>
  </ng-container>

  <!-- Estado -->
  <div style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
    <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Estado</span>
    <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 700; color: #111827;">{{ data.estadoActual }}</p>
  </div>

</div>

<!-- Footer -->
<div style="padding: 16px 24px; border-top: 1px solid #e5e7eb; display: flex; justify-content: flex-end;">
  <button type="button" (click)="onNoClick()"
    style="padding: 10px 28px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
    onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
    Cerrar
  </button>
</div>
